<script>
	export let query;
	export let search;

	let active = false;

	function focusInput() {
		active = true;
	}

	function handleEscape({key}) {
		if (key === 'Escape' || !key) {
			active = false;
		}
	}
</script>


<div 	class="search" 
		class:active={active}>
	

	<div class="input-wrapper">
		<svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="15" cy="10.5" r="10" stroke="#3B3B3B"/>
			<path d="M7.5 17L1 23.5" stroke="#3B3B3B"/>
		</svg>

		<input 	bind:value={query} 
				on:click={focusInput}
				on:input={search} 
				placeholder="search term"/>
	</div>
</div>


  <style lang="scss">
	@import "../main.scss";
	.search {
		border: 1px solid #ABABAB;
		background-color: #fff;
		border-radius: 5px;
		max-width: 580px;	
		margin: 0 auto;
		overflow: hidden;
		box-sizing: border-box;

		&.active {
			filter: drop-shadow(0px 4px 30px rgba(0, 0, 0, 0.25));
			max-width: 580px !important;
		}
	}

	.input-wrapper {
		display: flex;
		align-items: center;
		padding: 10px;
		box-sizing: border-box;

		svg {
			width: 24px;
			margin-right: 6px;
		}
		
		input {

			display: block;
			width: calc(100% - 30px);
			border: none;

			&:active, &:focus {
				border: none;
				outline: none;
			}
		}
	}
</style>
